//判断是否是生产环境
var isPro = process.env.NODE_ENV === 'production' //process.env.NODE_ENV用于区分是生产环境还是开发环境
//根据环境不同导出不同的baseURL
// let baseURL = isPro ? 'https://www.cismarket.cn' : 'https://www.cismarket.cn'
let baseURL = isPro ? '/api' : '/api'
let imgUrl = 'https://www.aghgzx.com';
// let imgUrl = 'https://gyl.kswlll.com';
// let imgUrl = 'https://supply.aghgzx.com';
export default {
  baseURL,
  imgUrl
}



// WEBPACK FOOTER //
// ./src/utils/config.js